import React, { useContext } from "react";
// @ts-ignore
import Banner from "./SatSubBanner";
import { FiLock } from "react-icons/fi";
import { BsFillCaretRightFill, BsFillBookmarkFill } from "react-icons/bs";
// @ts-ignore
import SatNavbar from "../../screens/SatCourse/CoursesScreen";
// @ts-ignore
import UserContext from "../../utils/UserContext";

export interface TopicsProps {
  isError: string | boolean;
  listData: any[];
  HAndleIndex: (item: any, index: number) => void;
  chaptertitle: string;
  progressPercent: number;
  about: string;
  HandleBookMark: (id: string | number, index: number) => void;
  HandleDeleteBookMark: (id: string | number, index: number) => void;
  chaptersCurrentIndex: number;
  HandleGoBack: () => void;
  isLoading?: boolean;
}

const Topics: React.FC<TopicsProps> = (props) => {
  const { checkSatNavbar, satChapters } = useContext<any>(UserContext);
  return (
    <div className="Home-Container">
      {props?.isError ? (
        <div className="chapter-lock-container ">
          <div className="topic-popup">
            <div className="chapter-lock">
              <div className="topic-title">Chapter Locked</div>
              <div className="topics-fi-lock">
                <FiLock size="25px" color="#898989" />
              </div>
              <div className="topic-lock-descrip">
                Next Chapter will be unlocked after 12 AM.
              </div>
              <div className="lock-btn" onClick={props.HandleGoBack}>
                OK
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="home-sub-container">
          {window.innerWidth < 1024 ? (
            <>{checkSatNavbar ? <SatNavbar /> : ""}</>
          ) : (
            <div className="cp-Navbar-container">
              <SatNavbar />
            </div>
          )}
          <div className="main-right-container">
            <div>
              {satChapters?.length === 0 ? (
                <Banner
                  title={props?.chaptertitle}
                  progressPercent={props?.progressPercent}
                  chaptersCount={props?.listData.length}
                  about={props?.about}
                  checkLesson={"topics"}
                />
              ) : (
                <Banner
                  title={satChapters[props.chaptersCurrentIndex]?.title}
                  progressPercent={
                    satChapters[props.chaptersCurrentIndex]?.progressPercent
                  }
                  chaptersCount={props?.listData.length}
                  about={satChapters[props.chaptersCurrentIndex]?.about}
                  checkLesson={"topics"}
                />
              )}
            </div>

            <div className="List-panel">
              <div>
                {props.isLoading ? (
                  [1, 2, 3, 4, 5].map((key) => (
                    <div className="list-item-panel placeholder-glow" key={key}>
                      <div className="list-item-left-section w-100">
                        <div className="list-item-id-panel placeholder" style={{ width: 40, height: 40, borderRadius: 20 }}></div>
                        <div className="list-item-title-panel ms-3 w-100">
                          <span className="placeholder d-block col-6 mb-2" style={{ height: 20, borderRadius: 4 }}></span>
                          <span className="placeholder d-block col-4" style={{ height: 16, borderRadius: 4 }}></span>
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  props.listData?.map((item, index) => {
                    return (
                    <React.Fragment key={item.id || index}>
                      <div
                        className={
                          item.lockStatus
                            ? "list-item-panel disable-div "
                            : "list-item-panel"
                        }
                      >
                        <div
                          className="list-item-left-section"
                          onClick={() => {
                            props.HAndleIndex(item, index);
                          }}
                        >
                          <div
                            className={
                              item.lockStatus
                                ? "list-item-id-panel list-icon-bg"
                                : "list-item-id-panel"
                            }
                          >
                            {item.lockStatus ? (
                              <>
                                <FiLock size="15px" color="#807f7f" />
                              </>
                            ) : (
                              <>
                                <div className="bs-care-bg">
                                  <BsFillCaretRightFill
                                    size="10px"
                                    color="#ffff"
                                  />
                                </div>
                              </>
                            )}
                          </div>
                          <div className="list-item-title-panel">
                            <div
                              className={
                                item.lockStatus
                                  ? "list-item-title-div l-t-disable"
                                  : "list-item-title-div"
                              }
                            >
                              <p>{item.title}</p>
                            </div>
                            <div className="list-item-lesson-panel">
                              <p>{item.videoDuration}</p>
                            </div>
                          </div>
                        </div>
                        <div className="list-item-icon-panel">
                          <BsFillBookmarkFill
                            onClick={() => {
                              item.isBookmarked
                                ? props.HandleDeleteBookMark(item.id, index)
                                : props.HandleBookMark(item.id, index);
                            }}
                            size="15px"
                            color={item.isBookmarked ? "#A20107" : "#C7C7C7"}
                          />
                        </div>
                      </div>
                    </React.Fragment>
                  );
                })
              )}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
export default React.memo(Topics);
